<!-- 根据数据处理 当前项为 el-submenu || el-menu-item -->
<template>
  <el-sub-menu v-if="route.children.length > 0" :index="route.path">
    <template #title>
        <menu-item :title="route.meta.title" :icon="route.meta?.icon"></menu-item>
    </template>
    <!-- 循环渲染 -->
    <sidebar-item
      v-for="item in route.children"
      :key="item.path"
      :route="item"
     />
  </el-sub-menu>
  <el-menu-item v-else :index="route.path">
    <!-- 渲染item  -->
    <menu-item :title="route.meta.title" :icon="route.meta?.icon"></menu-item>
  </el-menu-item>
</template>

<script setup>
import { defineProps } from 'vue'
import MenuItem from './MenuItem.vue'
defineProps({
  route: {
    type: Object,
    require: true
  }
})
</script>

<style lang='scss' scoped>
::v-deep .el-menu-item.is-active {
  background-color: #4D9262 !important;
}
</style>
